module.exports = __webpack_public_path__ + "img/bullhorn.7f8a8188.svg";